// src/amplify-config.ts
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_nudIAhbsA',
      userPoolClientId: 'mnjnio04f32ficclndfcf3usj',
      loginWith: {
        oauth: {
          domain: 'aiwf-test2.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],  // ← ADD THIS
          redirectSignIn: [
            'http://localhost:3000',
            'https://aiworkflowmarket.com',
            'https://www.aiworkflowmarket.com'
          ],
          redirectSignOut: [
            'http://localhost:3000',
            'https://aiworkflowmarket.com',
            'https://www.aiworkflowmarket.com'
          ],
          responseType: 'code'
        }
      }
    }
  }
});